<template>
  <v-layout column>
    <v-flex xs11 offset-xs0>
      <panel title="Browse Ranks">
        <!-- <v-btn
          slot="action"
          class="indigo accent-1"
          :to="{name:'rank-create'}"
          light
          small
          absolute
          right
          middle
          fab
        > 
          <v-icon>add</v-icon>
        </v-btn>-->
        <RankCreate v-if ='$store.state.isEditor' slot="action"/>

        <div slot="top">
         
          <div> <!-- :pagination.sync="pagination" :total-items="totalItems" -->
            <v-data-table :headers="headers" :items="ranks" hide-actions class="elevation-1"
                 :loading="loading" noDataText="Searching...">
              <template slot="items" slot-scope="props">
                <td class="text-xs-left pa-1">
                    <a :href="'/rank/' + props.item.type + '/' + props.item.id">
                    {{ props.item.name }}
                    </a>
                </td>
                <td class="text-xs-left pa-2">{{ $codeToService(props.item.type) }}</td> 
                <td class="text-xs-right pa-2">{{ props.item.count }}</td>                   

              </template>
              <template slot="footer">

                <td :colspan="1" style="margin:0;padding:0">
                  <v-layout row wrap pa-0 ma-0>

                    <v-flex>
                      <v-text-field box
                        v-model="name" v-on:keyup.enter="doSearch" label="Rank name"></v-text-field>
                    </v-flex>
                  </v-layout>
                </td>
                <td :colspan="1" style="margin:0;padding:0">
                  <v-layout row wrap pa-0 ma-0>
                    <v-flex >
                      <v-select box label="Service" v-model="service" 
                        :items=serviceValues></v-select>
                    </v-flex>
                  </v-layout>
                </td>                 
                <td :colspan="1" style="margin:0;padding:0">
                </td>                
              </template>
              <template slot="no-data">
                <div v-if="(finalCount === 0)">
                <v-alert
                  :value="true"
                  color="error"
                  icon="warning"
                >Nothing found :(</v-alert></div>
              </template>
            </v-data-table>
          </div>

          <!-- div>  start {{ start }} pagesize {{ pageSize }} totalItems {{ totalItems }} finalCount {{ finalCount }}</div -->

          <div style='margin-top:10px;margin-bottom:10px'>           
            <v-btn  class="blue-grey lighten-3" @click='goto(0)' :disabled=isAtStart>Start</v-btn>  
            <v-btn  class="blue-grey lighten-3" @click='goto(-1)' :disabled=isAtStart>Prev</v-btn>  
            <v-btn  class="blue-grey lighten-3" @click='goto(1)' :disabled=isAtEnd>Next</v-btn>
            <v-btn  class="blue-grey lighten-3" @click='goto(2)' :disabled=endIsUnknownOrNotThere>End</v-btn>
          </div>
        </div>         
      </panel>            
    </v-flex>
  </v-layout>
</template>

<script>
import RankService from "@/services/RankService" ;
import Panel from "@/components/Panel" ;
import RankCreate from "./RankCreate" ;
export default {
  components: { Panel, RankCreate },
  data () {
    return {
      name: '',
      ranks: [ ],
      start: 0,
      pageSize: 10,
      totalItems: 0,
      finalCount: -1,
      loading: true,
      pagination: {},
      service: '',
      serviceValues: ['All', 'Army', 'Merchant Navy', 'RAAF', 'RAN'],

      headers: [
        { 
          text: "Name",
          align: "left",
          sortable: false,
          width: "60%",
          class: "pa-1"
        },
        { text: "Service", sortable: false, width: "20%", class: "pa-2" },
        { text: "Count of members", sortable: false, width: "20%", class: "pa-2" }
      ]     
    };
  },
  methods: {
    async goto (inc) {
      if (inc === 1) {
        if (this.finalCount < 0) this.start += this.pageSize ;
        else if ((this.start + this.pageSize) < this.finalCount) this.start += this.pageSize ;
      }
      else if (inc === -1) {
        this.start -= this.pageSize ;
        if (this.start < 0) this.start = 0 ;
      }
      else if (inc === 2) { // goto the end
        this.start = this.finalCount - this.pageSize ;
        if (this.start < 0) this.start = 0 ;
      }
      else this.start = 0 ;
      await this.readData() ;
    },

    async doSearch () {  
      const route = {
        name: this.$route.name,
        service: this.$route.service,
        query: { }
      }
      if (this.name.length > 0) route.query.name = this.name ;
      if (this.service.length > 0) route.query.service = this.service ;
      this.$router.push(route) ;
    },

    async readData () {
      this.loading = true ;
      // let search = this.search.trim().toLowerCase() ;
      // console.log("search " + search + " sortby " + sortBy + " descending " + descending + " page " + page + " rowsPerPage " + rowsPerPage) ;

      let result = null ;
      try { // 1 mar22
        result = await RankService.index(this.name, this.$serviceToCode(this.service), this.start, this.pageSize) ;
      }
      catch (e) {
        console.log("RankService index err was " + e) ;
        alert("got error " + e + " - you may need to login") ;
        return ;
      }
      // 1mar22 const result = await RankService.index(this.name, this.$serviceToCode(this.service), this.start, this.pageSize) ;
      
      this.ranks = result.data ;
      if (this.ranks.length < 1) { // at the end
        if (this.finalCount < 0) {
          this.finalCount = this.totalItems ;
          await this.goto(-1) ;
          return ;
        }
      }
      if (this.finalCount < 0) {
        if ((this.start >= this.totalItems)) this.totalItems += this.ranks.length ;
        console.log("  set  this.totalItems " + this.totalItems)
      }
      if (this.ranks.length < this.pageSize) { // we've tricked to the end
        console.log("set final count to " + this.totalItems)
        this.finalCount = this.totalItems ;
      }
      this.loading = false ;
      console.log("in getdatafrom api data len " + this.ranks.length)
    }
  },

  // to do: https://vuetifyjs.com/en/components/autocompletes
  
  watch: {
    service: {
      async handler () {
        console.log("Service changed to " + this.service) ;
        this.doSearch() ;
      }
    }   
  },
  async created () {
    await this.$getCodes() ;  // needed for everything - make sure we have them and they are up to date
  },  
  async mounted () {
    console.log("in mounted") ;
    if (this.$route.query) {
      this.name = this.$route.query.name || '' ;
      this.service = this.$route.query.service || '' ;
    }
    await this.readData() ;
  },
  computed: { 
    isAtStart () {
      return (this.start < 1) ;
    },
    isAtEnd () {
      if (this.finalCount < 0) return false ;
      if ((this.start + this.pageSize) >= this.finalCount) return true ;
      return false ;
    },
    endIsUnknownOrNotThere () {
      if (this.finalCount < 0) return true ;
      if ((this.start + this.pageSize) >= this.finalCount) return true ;
      return false ;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Ranks.vue